import { ErrorToastItem } from './ErrorToastItem';
import { useErrorToast } from '@/context/ErrorToastContext';

export function GlobalErrorToast() {
  const { errors, dismissError } = useErrorToast();

  if (errors.length === 0) return null;

  return (
    <div
      className="pointer-events-none fixed left-1/2 z-flash flex w-full max-w-md -translate-x-1/2 flex-col gap-2 px-4"
      style={{ top: 'calc(env(safe-area-inset-top, 0px) + 1rem)' }}
    >
      {errors.map((error) => (
        <ErrorToastItem key={error.id} error={error} onDismiss={dismissError} />
      ))}
    </div>
  );
}
